import { createSlice } from "@reduxjs/toolkit";
import { convertDateObjToServerDate, getEndOfDay } from "../../../../../utils/datetimeutil";

const today = new Date();
const getEndDate = getEndOfDay(today);
const getStartDateFromEndDate = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate() + 1);

const downloadsLogSlice = createSlice({
  name: "download-log",
  initialState: {
    fromDate: convertDateObjToServerDate(getStartDateFromEndDate, true),
    toDate: convertDateObjToServerDate(getEndDate, true),
    baseCode: null,
    prefectureUuid: null
  },
  reducers: {
    clearState(state) {
      state.fromDate = convertDateObjToServerDate(getStartDateFromEndDate, true);
      state.toDate = convertDateObjToServerDate(getEndDate, true);
      state.baseCode = null;
      state.prefectureUuid = null;
    },
    setFromDate(state, action) {
      state.fromDate = action.payload;
    },
    setToDate(state, action) {
      state.toDate = action.payload;
    },
    setLocation(state, action) {
      state.baseCode = action.payload;
    },
    setPrefectureUuid(state, action) {
      state.prefectureUuid = action.payload;
    }
  }
});

export const {
  clearState: clearDownloadLogState,
  setFromDate: setDownloadLogFromDate,
  setToDate: setDownloadLogToDate,
  setLocation: setDownloadLogLocation,
  setPrefectureUuid: setDownloadLogPrefectureUuid
} = downloadsLogSlice.actions;

export default downloadsLogSlice.reducer;
